import { axiosApi } from './helper'

export function getReportTypes() {
  return axiosApi('reportTypes', {}, 'get')
}

export function createReport(data) {
  return axiosApi('reports', data, 'post')
}
